export default {
  title: 'Emeklilik Ui'
};
